module.exports = __webpack_public_path__ + "static/media/myriad-pharmaceuticals-certification.b468811d.png";